import { render, staticRenderFns } from "./settings-row.vue?vue&type=template&id=c3b5e39c&scoped=true&"
import script from "./settings-row.vue?vue&type=script&lang=js&"
export * from "./settings-row.vue?vue&type=script&lang=js&"
import style0 from "./settings-row.vue?vue&type=style&index=0&id=c3b5e39c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b5e39c",
  null
  
)

export default component.exports